<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('zhuima.taskUser.facebookNum')" prop="facebookNum" >
        <a-input v-model="form.facebookNum" :placeholder="$t('zhuima.taskUser.inputFacebookNum')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.isFackbook')" prop="isFackbook" >
        <a-input v-model="form.isFackbook" :placeholder="$t('zhuima.taskUser.inputIsFackbook')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.youtubeNum')" prop="youtubeNum" >
        <a-input v-model="form.youtubeNum" :placeholder="$t('zhuima.taskUser.inputYoutubeNum')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.isYoutube')" prop="isYoutube" >
        <a-input v-model="form.isYoutube" :placeholder="$t('zhuima.taskUser.inputIsYoutube')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.tiktok')" prop="tiktok" >
        <a-input v-model="form.tiktok" :placeholder="$t('zhuima.taskUser.inputTiktok')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.isTiktok')" prop="isTiktok" >
        <a-input v-model="form.isTiktok" :placeholder="$t('zhuima.taskUser.inputIsTiktok')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.openMessage')" prop="openMessage" >
        <a-input v-model="form.openMessage" :placeholder="$t('zhuima.taskUser.inputOpenMessage')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.isOpen')" prop="isOpen" >
        <a-input v-model="form.isOpen" :placeholder="$t('zhuima.taskUser.inputIsOpen')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.likeNum')" prop="likeNum" >
        <a-input v-model="form.likeNum" :placeholder="$t('zhuima.taskUser.inputLikeNum')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskUser.isLike')" prop="isLike" >
        <a-input v-model="form.isLike" :placeholder="$t('zhuima.taskUser.inputIsLike')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.remark')" prop="remark" >
        <a-input v-model="form.remark" :placeholder="$t('system.inputPlaceholder')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTaskUser, addTaskUser, updateTaskUser } from '@/api/taskUser/taskUser'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        facebookNum: null,

        isFackbook: null,

        youtubeNum: null,

        isYoutube: null,

        tiktok: null,

        isTiktok: null,

        openMessage: null,

        isOpen: null,

        likeNum: null,

        isLike: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        facebookNum: null,
        isFackbook: null,
        youtubeNum: null,
        isYoutube: null,
        tiktok: null,
        isTiktok: null,
        openMessage: null,
        isOpen: null,
        likeNum: null,
        isLike: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskUser({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateTaskUser(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addTaskUser(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
